import { useContext } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LayoutContext, ILayoutContext } from '../';

export default function MustBeLogged() {
  const { t } = useTranslation();

  const layoutContext = useContext(LayoutContext) as ILayoutContext;

  return (
    <div className="mustbelogged">
      <h3 className="text-center">{t('must-be-logged')}</h3>

      <Button onClick={layoutContext.onAccess}
        variant="outlined">{t('login')}</Button>
    </div>);
}